import axios from "axios";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";
const saleUrl = "sale/api/v1/";

export default {
  // CampaignType Actions ------------------------------------------------------------------
  getCampaignTypes({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/marketing/CampaignType")
      .then((res) => {
        commit("setCampaignTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addCampaignType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/marketing/CampaignType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCampaignType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/marketing/CampaignType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCampaignType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/marketing/CampaignType", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCampaignTypeCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/marketing/CampaignType/MaxCode")
      .then((res) => {
        commit("setCampaignTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Campaign Actions ------------------------------------------------------------------
  getCampaigns({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/marketing/Campaign")
      .then((res) => {
        commit("setCampaigns", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCampaign({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/marketing/Campaign/" + data)
      .then((res) => {
        commit("setCampaign", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCampaign({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(saleUrl + "basic/marketing/Campaign", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200 ? res.data.data : null;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  campainSendSms({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/marketing/Campaign/SendSms", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.send,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCampaign({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(saleUrl + "basic/marketing/Campaign/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCampaign({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/marketing/Campaign", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCampaignCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/marketing/Campaign/MaxCode")
      .then((res) => {
        commit("setCampaignCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // LeadType Actions ------------------------------------------------------------------
  getLeadTypes({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/marketing/LeadType")
      .then((res) => {
        commit("setLeadTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getLeadType({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/marketing/LeadType/" + data)
      .then((res) => {
        commit("setLeadType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addLeadType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/marketing/LeadType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editLeadType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/marketing/LeadType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteLeadType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/marketing/LeadType", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getLeadTypeCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/marketing/LeadType/MaxCode")
      .then((res) => {
        commit("setLeadTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // LeadProperty Actions ------------------------------------------------------------------
  getLeadPropertys({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/marketing/LeadProperty")
      .then((res) => {
        commit("setLeadPropertys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getLeadProperty({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/marketing/LeadProperty/" + data)
      .then((res) => {
        commit("setLeadProperty", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addLeadProperty({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/marketing/LeadProperty", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editLeadProperty({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/marketing/LeadProperty/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteLeadProperty({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/marketing/LeadProperty", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getLeadPropertyCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/marketing/LeadProperty/MaxCode")
      .then((res) => {
        commit("setLeadPropertyCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // LeadSource Actions ------------------------------------------------------------------
  getLeadSources({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/marketing/LeadSource")
      .then((res) => {
        commit("setLeadSources", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getLeadSource({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/marketing/LeadSource/" + data)
      .then((res) => {
        commit("setLeadSource", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addLeadSource({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/marketing/LeadSource", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editLeadSource({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/marketing/LeadSource/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteLeadSource({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/marketing/LeadSource", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getLeadSourceCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/marketing/LeadSource/MaxCode")
      .then((res) => {
        commit("setLeadSourceCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // ChancePriority Actions ------------------------------------------------------------------
  getChancePrioritys({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/marketing/ChancePriority")
      .then((res) => {
        commit("setChancePrioritys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getChancePriority({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/marketing/ChancePriority/" + data)
      .then((res) => {
        commit("setChancePriority", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addChancePriority({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/marketing/ChancePriority", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editChancePriority({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/marketing/ChancePriority/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteChancePriority({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/marketing/ChancePriority", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getChancePriorityCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/marketing/ChancePriority/MaxCode")
      .then((res) => {
        commit("setChancePriorityCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // FailedSaleReason Actions ------------------------------------------------------------------
  getFailedSaleReasons({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/marketing/FailedSaleReason")
      .then((res) => {
        commit("setFailedSaleReasons", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addFailedSaleReason({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/marketing/FailedSaleReason", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editFailedSaleReason({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/marketing/FailedSaleReason/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteFailedSaleReason({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/marketing/FailedSaleReason", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getFailedSaleReasonCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/marketing/FailedSaleReason/MaxCode")
      .then((res) => {
        commit("setFailedSaleReasonCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // StrengthWeakness Actions ------------------------------------------------------------------
  getStrengthWeaknesses({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/marketing/StrengthWeakness?" + data)
      .then((res) => {
        commit("setStrengthWeaknesses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getStrengthWeakness({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/marketing/StrengthWeakness/" + data)
      .then((res) => {
        commit("setStrengthWeakness", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addStrengthWeakness({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/marketing/StrengthWeakness", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editStrengthWeakness({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/marketing/StrengthWeakness/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteStrengthWeakness({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/marketing/StrengthWeakness", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getStrengthWeaknessCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/marketing/StrengthWeakness/MaxCode")
      .then((res) => {
        commit("setStrengthWeaknessCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // LeadEvaluationQuestion Actions ------------------------------------------------------------------
  getLeadEvaluationQuestions({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/marketing/LeadEvaluationQuestion?" + data)
      .then((res) => {
        commit("setLeadEvaluationQuestions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getLeadEvaluationQuestion({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "basic/marketing/LeadEvaluationQuestion/" + data)
      .then((res) => {
        commit("setLeadEvaluationQuestion", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addLeadEvaluationQuestion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/marketing/LeadEvaluationQuestion", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editLeadEvaluationQuestion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        saleUrl + "basic/marketing/LeadEvaluationQuestion/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // data: آرایه‌ی شناسه‌ها، مثل [12, 15]
  deleteLeadEvaluationQuestion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/marketing/LeadEvaluationQuestion", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getLeadEvaluationQuestionCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/marketing/LeadEvaluationQuestion/MaxCode")
      .then((res) => {
        commit("setLeadEvaluationQuestionCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // SaleRegion Actions ------------------------------------------------------------------
  getSaleRegions({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/marketing/SaleRegion?" + data)
      .then((res) => {
        commit("setSaleRegions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addSaleRegion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/marketing/SaleRegion", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSaleRegion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/marketing/SaleRegion/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // data: آرایه‌ی شناسه‌ها، مثل [12, 15]
  deleteSaleRegion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/marketing/SaleRegion", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSaleRegionCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/marketing/SaleRegion/MaxCode")
      .then((res) => {
        commit("setSaleRegionCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // SaleTeam Actions ------------------------------------------------------------------
  getSaleTeams({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "basic/marketing/SaleTeam?" + data)
      .then((res) => {
        commit("setSaleTeams", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSaleTeam({ dispatch }, id) {
    return axios
      .get(saleUrl + "basic/marketing/SaleTeam/" + id)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  addSaleTeam({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "basic/marketing/SaleTeam", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSaleTeam({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "basic/marketing/SaleTeam/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // data: آرایه‌ی شناسه‌ها، مثل [12, 15]
  deleteSaleTeam({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "basic/marketing/SaleTeam", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSaleTeamCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/marketing/SaleTeam/MaxCode")
      .then((res) => {
        commit("setSaleTeamCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Lead Actions ------------------------------------------------------------------
  getLeadCartable({ dispatch, commit }, { endpoint, payload }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
   
    const pageSize = 500;
    const fetchPage = (pageNumber, collected) =>
      axios
        .get(
          saleUrl +
            "operation/marketing/Lead/" +
            endpoint +
            "?" +
            (payload ? payload + "&" : "") +
            "PageNumber=" +
            pageNumber +
            "&PageSize=" +
            pageSize,
        )
        .then((res) => {
          const data = res.data.data;
          const rows = Array.isArray(data)
            ? data
            : data && Array.isArray(data.data)
            ? data.data
            : [];
          const all = collected.concat(rows);
          const pageCount =
            data && !Array.isArray(data) ? Number(data.pageCount) : 0;
          return rows.length && pageNumber < pageCount
            ? fetchPage(pageNumber + 1, all)
            : all;
        });
    fetchPage(1, [])
      .then((rows) => {
        commit("setLeads", rows);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getLeads({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "operation/marketing/Lead?" + data)
      .then((res) => {
        commit("setLeads", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getLead({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "operation/marketing/Lead/" + data)
      .then((res) => {
        commit("setLead", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addLead({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "operation/marketing/Lead", data)
      .then((res) => {
        commit("setLeadId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editLead({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "operation/marketing/Lead/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteLead({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "operation/marketing/Lead", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getLeadCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "operation/marketing/Lead/MaxCode")
      .then((res) => {
        commit("setLeadCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // کارت‌های خلاصه‌ی بالای لیست سرنخ‌ها
  getLeadStatistics({ dispatch, commit }) {
    axios
      .get(saleUrl + "operation/marketing/Lead/Statistics")
      .then((res) => {
        commit("setLeadStatistics", res.data.data || {});
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMarketingDashboard({ dispatch }, saleLineId) {
    const query = saleLineId ? "?saleLineId=" + saleLineId : "";
    return axios
      .get(saleUrl + "operation/marketing/Dashboard" + query)
      .then((res) => res.data.data || {})
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  getLeadRecord({ dispatch }, id) {
    return axios
      .get(saleUrl + "operation/marketing/Lead/" + id)
      .then((res) => res.data.data || null)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  // Follow up cartable ------------------------------------------------------------
  getFollowUpCartable({ dispatch }, params) {
    const query = [
      "PageNumber=" + params.pageNumber,
      "PageSize=" + params.pageSize,
    ];
    if (params.tabId) query.push("TabId=" + encodeURIComponent(params.tabId));
    (params.typeIds || []).forEach((typeId) => {
      query.push("TypeIds=" + encodeURIComponent(typeId));
    });
    return axios
      .get(saleUrl + "operation/marketing/FollowUpCartable?" + query.join("&"))
      .then((res) => res.data.data || {})
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  getFollowUpCartableTypes({ dispatch }) {
    return axios
      .get(saleUrl + "DropDown/FollowUpCartableType")
      .then((res) => (Array.isArray(res.data.data) ? res.data.data : []))
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return [];
      });
  },

  // جلسه تغییر وضعیت ندارد؛ بدنه‌ی وظیفه statusId و بدنه‌ی تماس callStatusId می‌گیرد
  changeFollowUpStatus({ dispatch }, data) {
    const body =
      data.entity === "Call"
        ? { id: data.id, callStatusId: data.statusId }
        : { id: data.id, statusId: data.statusId };
    return axios
      .put(
        saleUrl +
          "operation/hamyar/" +
          data.entity +
          "/ChangeStatus/" +
          data.id,
        body,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandlerSimple",
          { server: res, message: res.data.message || alert.success.save },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      });
  },

  // Activity calendar ------------------------------------------------------------
  // Task فیلتر تاریخ ندارد، پس هر سه فهرست کامل گرفته و در خود صفحه روی روزها
  // پخش می‌شوند؛ هر فهرستی که خطا بدهد null برمی‌گردد
  getCalendarActivities({ dispatch }) {
    const pageSize = 500;
    const rowsOf = (data) => {
      if (Array.isArray(data)) return data;
      return data && Array.isArray(data.data) ? data.data : [];
    };
    const allPages = (path, pageNumber, collected) =>
      axios
        .get(
          saleUrl +
            path +
            "?PageNumber=" +
            pageNumber +
            "&PageSize=" +
            pageSize,
        )
        .then((res) => {
          const data = res.data.data;
          const rows = rowsOf(data);
          const all = collected.concat(rows);
          const pageCount =
            data && !Array.isArray(data) ? Number(data.pageCount) : 0;
          return rows.length && pageNumber < pageCount
            ? allPages(path, pageNumber + 1, all)
            : all;
        })
        .catch((error) => {
          dispatch("errorGETHandler", error, { root: true });
          return null;
        });
    return Promise.all([
      allPages("operation/hamyar/Task", 1, []),
      allPages("operation/hamyar/Meeting", 1, []),
      allPages("operation/hamyar/Call", 1, []),
    ]).then(([tasks, meetings, calls]) => ({ tasks, meetings, calls }));
  },

  // Chance Actions ------------------------------------------------------------------
  getChances({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "operation/marketing/Chance?" + data)
      .then((res) => {
        commit("setChances", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getChance({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "operation/marketing/Chance/" + data)
      .then((res) => {
        commit("setChance", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addChance({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "operation/marketing/Chance", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editChance({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "operation/marketing/Chance/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  changeChanceStage({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(
        saleUrl + "operation/marketing/Chance/ChangeStage/" + data.id,
        data.value,
      )
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteChance({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "operation/marketing/Chance", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Competitor Actions ------------------------------------------------------------------
  getCompetitors({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "operation/marketing/Competitor?" + data)
      .then((res) => {
        commit("setCompetitors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCompetitor({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "operation/marketing/Competitor/" + data)
      .then((res) => {
        commit("setCompetitor", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCompetitor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "operation/marketing/Competitor", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCompetitor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "operation/marketing/Competitor/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCompetitor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "operation/marketing/Competitor", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // LeadAddress Actions ------------------------------------------------------------------
  getLeadAddresses({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "operation/marketing/LeadAddress?" + data)
      .then((res) => {
        commit("setLeadAddresses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getLeadAddress({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "operation/marketing/LeadAddress/" + data)
      .then((res) => {
        commit("setLeadAddress", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addLeadAddress({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "operation/marketing/LeadAddress", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editLeadAddress({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "operation/marketing/LeadAddress/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteLeadAddress({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "operation/marketing/LeadAddress", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // LeadContact Actions ------------------------------------------------------------------
  getLeadContactes({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(saleUrl + "operation/marketing/LeadContact?" + data)
      .then((res) => {
        commit("setLeadContactes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getLeadContact({ dispatch, commit }, data) {
    axios
      .get(saleUrl + "operation/marketing/LeadContact/" + data)
      .then((res) => {
        commit("setLeadContact", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addLeadContact({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(saleUrl + "operation/marketing/LeadContact", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editLeadContact({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "operation/marketing/LeadContact/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteLeadContact({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(saleUrl + "operation/marketing/LeadContact", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // SaleLine Actions ------------------------------------------------------------------
  getSaleLines({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    return axios
      .get(saleUrl + "basic/marketing/SaleLine?" + data)
      .then((res) => {
        commit("setSaleLines", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSaleLine({ dispatch }, id) {
    return axios
      .get(saleUrl + "basic/marketing/SaleLine/" + id)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  // صفحه بعد از ثبت فهرست را دوباره می‌گیرد، پس موفقیت برگردانده می‌شود
  addSaleLine({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(saleUrl + "basic/marketing/SaleLine", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSaleLine({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(saleUrl + "basic/marketing/SaleLine/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSaleLine({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .delete(saleUrl + "basic/marketing/SaleLine", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSaleLineCode({ dispatch, commit }) {
    axios
      .get(saleUrl + "basic/marketing/SaleLine/MaxCode")
      .then((res) => {
        commit("setSaleLineCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSaleLineDefaultStages({ dispatch }) {
    return axios
      .get(saleUrl + "basic/marketing/SaleLine/DefaultStages")
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return [];
      });
  },

  // SaleStage Actions ------------------------------------------------------------------
  getSaleStageCode({ dispatch, commit }) {
    return axios
      .get(saleUrl + "basic/marketing/SaleStage/MaxCode")
      .then((res) => {
        commit("setSaleStageCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  editSaleStage({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .put(saleUrl + "basic/marketing/SaleStage/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSaleStage({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .delete(saleUrl + "basic/marketing/SaleStage", {
        data,
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Lead 360 ------------------------------------------------------------------
  // وظیفه‌ها و تماس‌ها در سرویس با LeadId فیلتر می‌شوند؛ Chance این فیلتر را
  // ندارد، پس همه‌ی صفحه‌های فرصت گرفته و با leadId جدا می‌شوند
  getLead360({ dispatch }, leadId) {
    const rowsOf = (data) => {
      if (Array.isArray(data)) return data;
      return data && Array.isArray(data.data) ? data.data : [];
    };
    const list = (path) =>
      axios
        .get(saleUrl + path)
        .then((res) => rowsOf(res.data.data))
        .catch((error) => {
          dispatch("errorGETHandler", error, { root: true });
          return [];
        });
    // بدون PageNumber/PageSize فقط صفحه‌ی اول می‌آمد و فرصت تازه‌ی سرنخ دیده نمی‌شد
    const chancePageSize = 1000;
    const allChances = (pageNumber, collected) =>
      axios
        .get(
          saleUrl +
            "operation/marketing/Chance?PageNumber=" +
            pageNumber +
            "&PageSize=" +
            chancePageSize,
        )
        .then((res) => {
          const data = res.data.data;
          const rows = rowsOf(data);
          const all = collected.concat(rows);
          const pageCount =
            data && !Array.isArray(data) ? Number(data.pageCount) : 0;
          return rows.length && pageNumber < pageCount
            ? allChances(pageNumber + 1, all)
            : all;
        })
        .catch((error) => {
          dispatch("errorGETHandler", error, { root: true });
          return collected;
        });
    const query = "?LeadId=" + encodeURIComponent(leadId);
    const sameLead = (item) =>
      String(item.leadId).toLowerCase() === String(leadId).toLowerCase();
    return Promise.all([
      list("operation/hamyar/Task" + query),
      list("operation/hamyar/Call" + query),
      allChances(1, []),
    ]).then(([tasks, calls, chances]) => ({
      tasks,
      calls,
      chances: chances.filter(sameLead),
    }));
  },

  // جزئیات فرصت: فعالیت‌ها با فیلتر ChanceId از سرور می‌آیند؛ تماس فیلد فرصت ندارد و
  // با LeadId فرصت گرفته می‌شود؛ جلسه نه فیلد فرصت دارد نه فیلتر سرنخ، پس همه‌ی
  // صفحه‌های جلسه خوانده و روی leadId فرصت جدا می‌شوند
  getChanceDetail({ dispatch }, { chanceId, leadId }) {
    const pageSize = 1000;
    const allPages = (path, pageNumber = 1, collected = []) =>
      axios
        .get(
          saleUrl +
            path +
            (path.indexOf("?") === -1 ? "?" : "&") +
            "PageNumber=" +
            pageNumber +
            "&PageSize=" +
            pageSize,
        )
        .then((res) => {
          const data = res.data.data;
          const rows = Array.isArray(data)
            ? data
            : data && Array.isArray(data.data)
              ? data.data
              : [];
          const all = collected.concat(rows);
          const pageCount =
            data && !Array.isArray(data) ? Number(data.pageCount) : 0;
          return rows.length && pageNumber < pageCount
            ? allPages(path, pageNumber + 1, all)
            : all;
        })
        .catch((error) => {
          dispatch("errorGETHandler", error, { root: true });
          return collected;
        });
    const sameLead = (item) =>
      String(item.leadId).toLowerCase() === String(leadId).toLowerCase();
    // فهرست‌های فاکتور فروش و Order (پیش فاکتور/سفارش) صفحه‌بندی ندارند
    const list = (path) =>
      axios
        .get(saleUrl + path)
        .then((res) => {
          const data = res.data.data;
          if (Array.isArray(data)) return data;
          return data && Array.isArray(data.data) ? data.data : [];
        })
        .catch((error) => {
          dispatch("errorGETHandler", error, { root: true });
          return [];
        });
    const chance = encodeURIComponent(chanceId);
    const lead = encodeURIComponent(leadId || "");
    return Promise.all([
      allPages("operation/hamyar/Task?ChanceId=" + chance),
      leadId ? allPages("operation/hamyar/Meeting") : Promise.resolve([]),
      leadId
        ? allPages("operation/hamyar/Call?LeadId=" + lead)
        : Promise.resolve([]),
      list("operation/SaleFactor?chanceId=" + chance),
      list("operation/Order?chanceId=" + chance),
      allPages("operation/hamyar/Contract?ChanceId=" + chance),
      // عنوان نوع‌ها پیش فاکتور را از سفارش جدا می‌کند؛ نبودنش خطا نشان نمی‌دهد
      axios
        .get(saleUrl + "DropDown/OrderType")
        .then((res) => (Array.isArray(res.data.data) ? res.data.data : []))
        .catch(() => []),
    ]).then(
      ([
        tasks,
        meetings,
        calls,
        saleFactors,
        orders,
        contracts,
        orderTypes,
      ]) => ({
        tasks,
        meetings: meetings.filter(sameLead),
        calls,
          saleFactors,
        orders,
        contracts,
        orderTypes,
      }),
    );
  },

  // رکورد کامل یک فعالیت، تماس یا جلسه برای «جزئیات بیشتر»؛ چیزی در store نگه داشته نمی‌شود.
  // مدال فعالیت همیار هم تیم را جدا از TaskTeam می‌خواند
  getHamyarRecord({ dispatch }, { kind, id }) {
    const get = (path) =>
      axios.get(saleUrl + path).then((res) => res.data.data);
    const request =
      kind === "task"
        ? Promise.all([
            get("operation/hamyar/Task/" + id),
            get(
              "operation/hamyar/TaskTeam?TaskId=" +
                encodeURIComponent(id) +
                "&PageNumber=1&PageSize=1000",
            ).catch(() => null),
          ]).then(([task, teams]) => {
            const rows = Array.isArray(teams)
              ? teams
              : teams && Array.isArray(teams.data)
                ? teams.data
                : [];
            return rows.length ? { ...task, taskTeams: rows } : task;
          })
        : kind === "call"
          ? get("operation/hamyar/Call/" + id)
          : get("operation/hamyar/Meeting/" + id);
    return request.catch((error) => {
      dispatch("errorGETHandler", error, { root: true });
      return null;
    });
  },

  // تخصیص سرنخ به مسئول فروش؛ بدنه همان AssignLeadCommand است: { id, responsibleUserId }
  assignLead({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(saleUrl + "operation/marketing/Lead/Assign/" + data.id, data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Lead evaluation ------------------------------------------------------------------
  // سوال‌ها از DropDown/LeadEvaluationQuestion می‌آیند؛ اگر آیتم‌های dropdown فیلد
  // isRequired نداشتند، الزامی بودن از فهرست اطلاعات پایه‌ی همان سوال‌ها برداشته می‌شود
  getLeadEvaluationQuestionItems({ dispatch }) {
    const listOf = (data) => {
      if (Array.isArray(data)) return data;
      return data && Array.isArray(data.data) ? data.data : [];
    };
    const normalize = (item) => ({
      id: item.id !== undefined ? item.id : item.value,
      code: item.code,
      title: item.title !== undefined ? item.title : item.text,
      isRequired: item.isRequired,
    });
    const withFlags = (questions) =>
      questions.map((item) => ({
        ...item,
        isRequired: item.isRequired === true,
      }));
    return axios
      .get(saleUrl + "DropDown/LeadEvaluationQuestion")
      .then((res) =>
        listOf(res.data.data)
          .map(normalize)
          .filter((item) => item.id !== undefined && item.id !== null),
      )
      .then((questions) => {
        const hasFlags = questions.some(
          (item) => typeof item.isRequired === "boolean",
        );
        if (!questions.length || hasFlags) return withFlags(questions);
        return axios
          .get(
            saleUrl +
              "basic/marketing/LeadEvaluationQuestion?PageNumber=1&PageSize=1000000",
          )
          .then((res) => {
            const flags = {};
            listOf(res.data.data).forEach((item) => {
              flags[String(item.id)] = item.isRequired === true;
            });
            return questions.map((item) => ({
              ...item,
              isRequired: flags[String(item.id)] === true,
            }));
          })
          .catch(() => withFlags(questions));
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return [];
      });
  },

  // سوال‌ها، گزینه‌های نتیجه و خود سرنخ (پاسخ‌ها و نتیجه‌ی ارزیابی قبلی) با هم گرفته می‌شوند
  getLeadEvaluation({ dispatch }, leadId) {
    const results = axios
      .get(saleUrl + "DropDown/LeadEvaluationResult")
      .then((res) => {
        const data = res.data.data;
        if (Array.isArray(data)) return data;
        return data && Array.isArray(data.data) ? data.data : [];
      })
      .catch(() => []);
    const lead = axios
      .get(saleUrl + "operation/marketing/Lead/" + leadId)
      .then((res) => res.data.data || null)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
    return Promise.all([
      dispatch("getLeadEvaluationQuestionItems"),
      results,
      lead,
    ]).then(([questions, resultItems, record]) => ({
      questions,
      results: resultItems,
      lead: record,
    }));
  },

  // ثبت سریع سوال از داخل پنل ارزیابی؛ همان POST اطلاعات پایه با کد MaxCode.
  // postCheck نمی‌زند تا صفحه‌ی سرنخ‌ها وسط ارزیابی بارگذاری مجدد نشود
  addLeadEvaluationQuestionQuick({ dispatch, commit }, data) {
    return axios
      .get(saleUrl + "basic/marketing/LeadEvaluationQuestion/MaxCode")
      .then((res) =>
        axios.post(saleUrl + "basic/marketing/LeadEvaluationQuestion", {
          id: 0,
          code: Number(res.data.data) || 0,
          title: data.title,
          isRequired: data.isRequired === true,
        }),
      )
      .then((res) => {
        commit("setSuccess", alert.success.save, { root: true });
        const created = res.data && res.data.data;
        return {
          ok: true,
          id: created && typeof created === "object" ? created.id : created,
        };
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return { ok: false };
      });
  },

  // PUT operation/marketing/Lead/Evaluate/{id}؛ بدنه همان EvaluateLeadCommand است.
  // postCheck صفحه‌ی سرنخ‌ها را (جدول و کارت‌ها) بارگذاری مجدد می‌کند
  evaluateLead({ dispatch }, data) {
    return axios
      .put(saleUrl + "operation/marketing/Lead/Evaluate/" + data.id, data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      });
  },
  // Reports ------------------------------------------------------------------
  // GET marketing/Report/LeadChanceConversion؛ ردیف‌های گزارش تبدیل سرنخ و فرصت
  // بر اساس تاریخ ثبت فرصت: سرنخ به فرصت، سرنخ به مشتری، فرصت به هر مرحله،
  // از هر مرحله به مرحله‌ی آخر و نرخ تبدیل سرنخ به فروش
  // GET marketing/Report/SaleFunnel؛ مراحل هر خط فروش با تعداد و مبلغ فرصت‌ها.
  // شناسه‌ها همان عددهای خود سرویس‌اند و فیلترهای خالی فرستاده نمی‌شوند
  getSaleFunnelReport({ dispatch }, params) {
    const data = params || {};
    const query = [];
    const add = (name, value) => {
      if (value === null || value === undefined || value === "") return;
      query.push(name + "=" + encodeURIComponent(value));
    };
    add("SaleLineId", data.saleLineId);
    add("SaleTeamId", data.saleTeamId);
    add("SaleRegionId", data.saleRegionId);
    add("ChanceStatusId", data.chanceStatusId);
    add("FromDateLocal", data.fromDate);
    add("ToDateLocal", data.toDate);
    return axios
      .get(
        saleUrl +
          "marketing/Report/SaleFunnel" +
          (query.length ? "?" + query.join("&") : ""),
      )
      .then((res) => res.data.data || {})
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  getLeadChanceConversionReport({ dispatch }, params) {
    const data = params || {};
    const query = [];
    if (data.fromDate) {
      query.push("FromDateLocal=" + encodeURIComponent(data.fromDate));
    }
    if (data.toDate) {
      query.push("ToDateLocal=" + encodeURIComponent(data.toDate));
    }
    return axios
      .get(
        saleUrl +
          "marketing/Report/LeadChanceConversion" +
          (query.length ? "?" + query.join("&") : ""),
      )
      .then((res) => (Array.isArray(res.data.data) ? res.data.data : []))
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  // GET marketing/Report/LeadChanceConversionDetail؛ سرنخ‌های همان ردیف گزارش.
  // typeId همان مقداری است که خود ردیف برگردانده و دست‌کاری نمی‌شود؛ برای
  // ردیف‌های مرحله، saleStageId هم الزامی است
  getLeadChanceConversionReportDetail({ dispatch }, params) {
    const data = params || {};
    const query = [];
    if (data.typeId !== null && data.typeId !== undefined) {
      query.push("TypeId=" + encodeURIComponent(data.typeId));
    }
    if (data.saleStageId) {
      query.push("SaleStageId=" + encodeURIComponent(data.saleStageId));
    }
    if (data.fromDate) {
      query.push("FromDateLocal=" + encodeURIComponent(data.fromDate));
    }
    if (data.toDate) {
      query.push("ToDateLocal=" + encodeURIComponent(data.toDate));
    }
    return axios
      .get(
        saleUrl +
          "marketing/Report/LeadChanceConversionDetail" +
          (query.length ? "?" + query.join("&") : ""),
      )
      .then((res) => (Array.isArray(res.data.data) ? res.data.data : []))
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },
};
